// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.auth-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: linear-gradient(135deg, #faf5ff 0%, #ffffff 50%, #f0f9ff 100%);
}

.auth-card {
  width: 100%;
  max-width: 440px;
  background: #ffffff;
  border: 1px solid #e9d5ff;
  border-radius: 20px;
  box-shadow: 0 20px 50px rgba(99, 102, 241, 0.12);
  padding: 40px;
}

.auth-header {
  text-align: center;
  margin-bottom: 28px;
}

.auth-header h1 {
  font-size: 28px;
  font-weight: 800;
  background: linear-gradient(90deg, #6366f1, #8b5cf6);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  margin-bottom: 8px;
}

.auth-header p {
  color: #6b7280;
  font-size: 15px;
}

.error-message {
  background: #fef2f2;
  border: 1px solid #fecaca;
  color: #b91c1c;
  border-radius: 12px;
  padding: 12px 16px;
  font-size: 14px;
  margin-bottom: 20px;
}

.form-group .error-message {
  background: none;
  border: none;
  border-radius: 0;
  padding: 0;
  margin-bottom: 0;
  color: #e74c3c;
  font-size: 13px;
}

.password-field {
  position: relative;
  display: flex;
  flex-direction: column;
}

.password-field input {
  width: 100%;
  padding-right: 44px;
}

.password-toggle {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  background: none;
  border: none;
  padding: 4px;
  cursor: pointer;
  color: #9ca3af;
}

.password-toggle:hover {
  color: #6366f1;
}

.info-message {
  background: #f0fdf4;
  border: 1px solid #bbf7d0;
  color: #15803d;
  border-radius: 12px;
  padding: 12px 16px;
  font-size: 14px;
  margin-bottom: 20px;
}

.otp-inputs {
  display: flex;
  justify-content: center;
  gap: 10px;
}

.otp-input {
  width: 48px;
  height: 56px;
  text-align: center;
  font-size: 22px;
  font-weight: 700;
  color: #374151;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  outline: none;
  transition: border-color 0.2s, box-shadow 0.2s;
}

.otp-input:focus {
  border-color: #8b5cf6;
  box-shadow: 0 0 0 3px rgba(139, 92, 246, 0.15);
}

.resend-cooldown {
  color: #9ca3af;
  font-weight: 600;
}

.auth-form {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.form-group label {
  font-size: 14px;
  font-weight: 600;
  color: #374151;
}

.form-group input {
  padding: 12px 16px;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  font-size: 15px;
  outline: none;
  transition: border-color 0.2s, box-shadow 0.2s;
}

.form-group input:focus {
  border-color: #8b5cf6;
  box-shadow: 0 0 0 3px rgba(139, 92, 246, 0.15);
}

.form-group input.error,
.password-field input.error {
  border-color: #e74c3c;
}

.auth-button {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  margin-top: 6px;
  padding: 13px 16px;
  border: none;
  border-radius: 12px;
  background: linear-gradient(90deg, #6366f1, #8b5cf6);
  color: #ffffff;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: box-shadow 0.2s, transform 0.2s;
}

.auth-button:hover:not(:disabled) {
  box-shadow: 0 10px 25px rgba(99, 102, 241, 0.35);
  transform: translateY(-1px);
}

.auth-button:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.spinner {
  width: 16px;
  height: 16px;
  border: 2px solid rgba(255, 255, 255, 0.4);
  border-top-color: #ffffff;
  border-radius: 50%;
  animation: auth-spin 0.7s linear infinite;
}

@keyframes auth-spin {
  to {
    transform: rotate(360deg);
  }
}

.auth-footer {
  text-align: center;
  margin-top: 24px;
  font-size: 14px;
  color: #6b7280;
}

.link-button {
  background: none;
  border: none;
  padding: 0;
  color: #6366f1;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
}

.link-button:hover {
  text-decoration: underline;
}
`, "",{"version":3,"sources":["webpack://./src/components/Auth.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,0EAA0E;AAC5E;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,gDAAgD;EAChD,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oDAAoD;EACpD,6BAA6B;EAC7B,qBAAqB;EACrB,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,8CAA8C;AAChD;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,8CAA8C;AAChD;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,oDAAoD;EACpD,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,2CAA2C;AAC7C;;AAEA;EACE,gDAAgD;EAChD,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,yBAAyB;EACzB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B","sourcesContent":[".auth-container {\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px;\n  background: linear-gradient(135deg, #faf5ff 0%, #ffffff 50%, #f0f9ff 100%);\n}\n\n.auth-card {\n  width: 100%;\n  max-width: 440px;\n  background: #ffffff;\n  border: 1px solid #e9d5ff;\n  border-radius: 20px;\n  box-shadow: 0 20px 50px rgba(99, 102, 241, 0.12);\n  padding: 40px;\n}\n\n.auth-header {\n  text-align: center;\n  margin-bottom: 28px;\n}\n\n.auth-header h1 {\n  font-size: 28px;\n  font-weight: 800;\n  background: linear-gradient(90deg, #6366f1, #8b5cf6);\n  -webkit-background-clip: text;\n  background-clip: text;\n  -webkit-text-fill-color: transparent;\n  margin-bottom: 8px;\n}\n\n.auth-header p {\n  color: #6b7280;\n  font-size: 15px;\n}\n\n.error-message {\n  background: #fef2f2;\n  border: 1px solid #fecaca;\n  color: #b91c1c;\n  border-radius: 12px;\n  padding: 12px 16px;\n  font-size: 14px;\n  margin-bottom: 20px;\n}\n\n.form-group .error-message {\n  background: none;\n  border: none;\n  border-radius: 0;\n  padding: 0;\n  margin-bottom: 0;\n  color: #e74c3c;\n  font-size: 13px;\n}\n\n.password-field {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n}\n\n.password-field input {\n  width: 100%;\n  padding-right: 44px;\n}\n\n.password-toggle {\n  position: absolute;\n  right: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  display: flex;\n  align-items: center;\n  background: none;\n  border: none;\n  padding: 4px;\n  cursor: pointer;\n  color: #9ca3af;\n}\n\n.password-toggle:hover {\n  color: #6366f1;\n}\n\n.info-message {\n  background: #f0fdf4;\n  border: 1px solid #bbf7d0;\n  color: #15803d;\n  border-radius: 12px;\n  padding: 12px 16px;\n  font-size: 14px;\n  margin-bottom: 20px;\n}\n\n.otp-inputs {\n  display: flex;\n  justify-content: center;\n  gap: 10px;\n}\n\n.otp-input {\n  width: 48px;\n  height: 56px;\n  text-align: center;\n  font-size: 22px;\n  font-weight: 700;\n  color: #374151;\n  border: 1px solid #e5e7eb;\n  border-radius: 12px;\n  outline: none;\n  transition: border-color 0.2s, box-shadow 0.2s;\n}\n\n.otp-input:focus {\n  border-color: #8b5cf6;\n  box-shadow: 0 0 0 3px rgba(139, 92, 246, 0.15);\n}\n\n.resend-cooldown {\n  color: #9ca3af;\n  font-weight: 600;\n}\n\n.auth-form {\n  display: flex;\n  flex-direction: column;\n  gap: 18px;\n}\n\n.form-group {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.form-group label {\n  font-size: 14px;\n  font-weight: 600;\n  color: #374151;\n}\n\n.form-group input {\n  padding: 12px 16px;\n  border: 1px solid #e5e7eb;\n  border-radius: 12px;\n  font-size: 15px;\n  outline: none;\n  transition: border-color 0.2s, box-shadow 0.2s;\n}\n\n.form-group input:focus {\n  border-color: #8b5cf6;\n  box-shadow: 0 0 0 3px rgba(139, 92, 246, 0.15);\n}\n\n.form-group input.error,\n.password-field input.error {\n  border-color: #e74c3c;\n}\n\n.auth-button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  margin-top: 6px;\n  padding: 13px 16px;\n  border: none;\n  border-radius: 12px;\n  background: linear-gradient(90deg, #6366f1, #8b5cf6);\n  color: #ffffff;\n  font-size: 15px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: box-shadow 0.2s, transform 0.2s;\n}\n\n.auth-button:hover:not(:disabled) {\n  box-shadow: 0 10px 25px rgba(99, 102, 241, 0.35);\n  transform: translateY(-1px);\n}\n\n.auth-button:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n}\n\n.spinner {\n  width: 16px;\n  height: 16px;\n  border: 2px solid rgba(255, 255, 255, 0.4);\n  border-top-color: #ffffff;\n  border-radius: 50%;\n  animation: auth-spin 0.7s linear infinite;\n}\n\n@keyframes auth-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.auth-footer {\n  text-align: center;\n  margin-top: 24px;\n  font-size: 14px;\n  color: #6b7280;\n}\n\n.link-button {\n  background: none;\n  border: none;\n  padding: 0;\n  color: #6366f1;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.link-button:hover {\n  text-decoration: underline;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
